export default "https://cdn-gra.amplement.io/statics/images/fallbackAvatar.svg";